import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, NgZone } from '@angular/core';
import { ApiService } from '../service/api.service.js';
import { AuthenticationService } from '../service/authentication.service.js';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants.js';
import { isNullOrUndefined } from 'util';
import { VehicleService } from '../service/vehicle.service.js';
import { EnrollmentConstants } from '../constants/enrollment-constants.js';
import { ToastService } from '../service/toast.service.js';
const PAGE_SIZE: number = 25;

@Component({
  selector: 'app-vehicle-history-event',
  templateUrl: './vehicle-history-event.component.html',
  styleUrls: ['./vehicle-history-event.component.scss']
})
export class VehicleHistoryEventComponent implements OnInit {

  @Input() account;
  @Input() vehicleData;

  eventList = [];
  previousPage: number;
  currentPage: number;
  nextPage: number;

  messageMap = new Map([
    ["VEHICLE_ENROLLMENT", "Vehicle enrolled"],
    ["VEHICLE_UNENROLLMENT", "Vehicle unenrolled"],
    ["VEHICLE_SERVICE_PACKAGE_PROVISIONING_CREATE", "%s added to vehicle"],
    ["VEHICLE_SERVICE_PACKAGE_PROVISIONING_DELETE", "%s deleted from vehicle"],
    ["VEHICLE_ONBOARDING", "Vehicle added"],
    ["TSP_DELETE_VEHICLE", "Vehicle deleted"]
  ]);

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private zone: NgZone,
    private vehicleService: VehicleService, private toastService: ToastService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("vehicle data: ", this.vehicleData);
    this.getVehicleEvent(0);
  }


  getVehicleEvent(page) {
    this.utilService.showSpinner();
    this.apiService.getVehicleEvent(this.account.id, this.vehicleData.vin, page, PAGE_SIZE).then((data) => {
      this.utilService.hideSpinner();
      this.eventList = data.data;
      console.log("Vehicle events::", this.eventList);
      this.nextPage = data.nextPage;
      this.currentPage = data.curPage;
      this.previousPage = data.prevPage;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehicleEvent(page);
        });
      }
      else {
        this.utilService.hideSpinner();
        // if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        // else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getPreviousPage() {
    this.getVehicleEvent(this.previousPage);
  }

  getNextPage() {
    this.getVehicleEvent(this.nextPage);
  }

  getAction(rowData: any) {

    var message = "";
    var key = rowData.serviceName;
    if (rowData.command) {
      key = key + "_" + rowData.command;
    }

    switch (rowData.serviceName) {
      case "VEHICLE_ENROLLMENT":
        message = this.utilService.stringFormat(this.messageMap.get(key), "");
        break;
      case "VEHICLE_UNENROLLMENT":
        message = this.utilService.stringFormat(this.messageMap.get(key), "");
        break;
      case "VEHICLE_SERVICE_PACKAGE_PROVISIONING":
        message = this.utilService.stringFormat(this.messageMap.get(key), rowData.packageName);
        break;
      case "VEHICLE_ONBOARDING":
        message = this.utilService.stringFormat(this.messageMap.get(key), "");
        break;
      case "TSP_DELETE_VEHICLE":
        message = this.utilService.stringFormat(this.messageMap.get(key), "");
        break;
      default:
        message = rowData.message;
        break;
    }
    // console.log("Action : ", message);
    if (!message || message == '')
      message = rowData.message;
    
    return message;
  }
}
